import type { ResolvedTheme, PdfThemeTokens } from '../types';

export const PDF_THEME_TOKENS: Record<ResolvedTheme, PdfThemeTokens> = {
  dark: {
    canvasBg: [9, 15, 25],          // #090F19 (Obsidian Navy Slate)
    panelBg: [19, 31, 51],         // #131F33 (Container Surface)
    border: [30, 41, 59],          // #1E293B (Slate 800)
    borderMuted: [23, 35, 56],     // #172338 (Subtle Divider)
    textPrimary: [248, 250, 252],  // #F8FAFC (18.33:1 Contrast, WCAG AAA)
    textMuted: [148, 163, 184],    // #94A3B8 (7.52:1 Contrast, WCAG AAA)
    textFaint: [100, 116, 139],    // #64748B (4.15:1 Contrast)
    accentTeal: [20, 184, 166],    // #14B8A6 (Teal 500, 7.71:1 Contrast)
    accentTealText: [45, 212, 191], // #2DD4BF (Teal 400, 11.31:1 Contrast)
    accentAmber: [245, 158, 11],   // #F59E0B (Amber 500, 8.95:1 Contrast)
    accentAmberText: [251, 191, 36],// #FBBF24 (Amber 400, 11.58:1 Contrast)
    chipBgNeutral: [20, 33, 55],   // #142137
    chipBorderNeutral: [30, 41, 59], // #1E293B
    chipTextNeutral: [248, 250, 252],
    chipBgTeal: [12, 35, 41],      // #0C2329
    chipBorderTeal: [20, 184, 166],
    chipTextTeal: [45, 212, 191],
    linkText: [45, 212, 191],      // #2DD4BF
    linkUnderline: [20, 184, 166],
  },
  light: {
    canvasBg: [255, 255, 255],     // #FFFFFF (Clean White Paper Base)
    panelBg: [248, 250, 252],      // #F8FAFC (Slate 50 Tint Container)
    border: [226, 232, 240],       // #E2E8F0 (Slate 200 Hairline)
    borderMuted: [241, 245, 249],  // #F1F5F9 (Subtle Divider)
    textPrimary: [15, 23, 42],     // #0F172A (17.86:1 Contrast, WCAG AAA)
    textMuted: [71, 85, 105],      // #475569 (7.56:1 Contrast, WCAG AAA)
    textFaint: [100, 116, 139],    // #64748B (4.63:1 Contrast, WCAG AA)
    accentTeal: [13, 148, 136],    // #0D9488 (Teal 600, 3.71:1 Graphical)
    accentTealText: [15, 118, 110],// #0F766E (Teal 700, 5.12:1 Contrast, WCAG AA)
    accentAmber: [217, 119, 6],    // #D97706 (Amber 600, 3.17:1 Graphical)
    accentAmberText: [180, 83, 9],  // #B45309 (Amber 700, 5.00:1 Contrast, WCAG AA)
    chipBgNeutral: [241, 245, 249],// #F1F5F9 (Slate 100)
    chipBorderNeutral: [226, 232, 240],
    chipTextNeutral: [15, 23, 42],
    chipBgTeal: [240, 253, 250],   // #F0FDFA (Teal 50)
    chipBorderTeal: [153, 246, 228],
    chipTextTeal: [15, 118, 110],  // #0F766E
    linkText: [15, 118, 110],      // #0F766E
    linkUnderline: [13, 148, 136],
  },
};

export function getPdfThemeTokens(theme: ResolvedTheme = 'dark'): PdfThemeTokens {
  return PDF_THEME_TOKENS[theme] ?? PDF_THEME_TOKENS.dark;
}
